import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { PlayerActivityLogType as PlayerActivityLogType } from '@/schema'
import { PlayerActivityLogModel } from '@/modules/manage-player/type'
import { activityLogTypeTranslations } from './translations'

export const columns: ColumnDef<PlayerActivityLogModel>[] = [
	{
		accessorKey: 'type',
		header: 'ประเภทการทำรายการ',
		size: 120,
		cell: ({ row }) =>
			activityLogTypeTranslations[row.original.type as PlayerActivityLogType] ||
			row.original.type,
	},
	{
		accessorKey: 'message',
		header: 'รายละเอียดการทำรายการ',
		cell: ({ row }) => (
			<div className="max-w-[500px] whitespace-pre-wrap break-words">
				{row.original.message}
			</div>
		),
	},
	{
		accessorKey: 'note',
		header: 'หมายเหตุ',
		size: 200,
		cell: ({ row }) =>
			row.original.note ? (
				<div className="max-w-[200px] whitespace-pre-wrap break-words text-muted-foreground">
					{row.original.note}
				</div>
			) : (
				'-'
			),
	},
	{
		accessorKey: 'createdAt',
		header: 'ทำรายการเมื่อ',
		size: 180,
		cell: ({ row }) =>
			format(new Date(row.original.createdAt), 'yyyy-MM-dd HH:mm:ss'),
	},
]

export const ACTIVITY_LOG_TYPE_OPTIONS = Object.entries(
	activityLogTypeTranslations,
).map(([value, label]) => ({
	label,
	value,
}))
